module.exports = __webpack_public_path__ + "static/media/gift_closed.cfeff3f7.gif";